import OperateInspectionPlanHome from './views/Home.vue'
import OperateInspectionPlanInspectionList from './views/InspectionPlanInspectionList.vue'
import OperateInspectionPlanProductDetail from './views/InspectionPlanProductDetail.vue'
import OperateInspectionPlanProductList from './views/InspectionPlanProductList.vue'

export default {
  routes: [
    {
      path: '/operate/inspection_plan',
      component: OperateInspectionPlanHome,
      name: 'OperateInspectionPlanHome',
      meta: { requiresAuth: true },
      children: [
        {
          path: 'products',
          component: OperateInspectionPlanProductList,
          name: 'OperateInspectionPlanProductList',
        },
        {
          path: 'products/:id([0-9]+)',
          component: OperateInspectionPlanProductDetail,
          name: 'OperateInspectionPlanProductDetail',
          props: (route) => ({ id: Number(route.params.id) }),
        },
        {
          path: 'inspections',
          component: OperateInspectionPlanInspectionList,
          name: 'OperateInspectionPlanInspectionList',
        },
      ],
    },
  ],
}
